import clsx from 'clsx'

export function SegmentedControl<T extends string>({
  value,
  onChange,
  options,
  disabled,
  className,
  'aria-label': ariaLabel,
}: {
  value: T
  onChange: (v: T) => void
  options: { value: T; label: string; count?: number }[]
  disabled?: boolean
  className?: string
  'aria-label'?: string
}) {
  return (
    <div className={clsx('stryzh-segmented', className)} role="radiogroup" aria-label={ariaLabel}>
      {options.map((o) => (
        <button
          key={o.value}
          type="button"
          role="radio"
          aria-checked={value === o.value}
          disabled={disabled}
          className={clsx(
            'stryzh-segmented__btn',
            value === o.value && 'stryzh-segmented__btn--active',
          )}
          onClick={() => onChange(o.value)}
        >
          {o.label}
          {o.count != null ? (
            <span className="stryzh-segmented__count" aria-label={`(${o.count})`}>
              {o.count}
            </span>
          ) : null}
        </button>
      ))}
    </div>
  )
}
